import { render } from "./dialogsave.vue?vue&type=template&id=ffb298f4"
import script from "./dialogsave.vue?vue&type=script&lang=js"
export * from "./dialogsave.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__